export default __webpack_public_path__ + "static/media/sy.74868dc5.svg";